module.exports = __webpack_public_path__ + "static/media/arrow-blue-down.07f640c5.png";